/* @flow */
import * as React from 'react';
import assertions from 'lib/assertions';
import FormElement from 'components/FormElement.jsx';
import Button from 'components/Button.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import ToastActions from 'actions/ToastActions';
import DeviceActions from 'actions/DeviceActions';
import PhoneNumberMaskedInput from 'components/PhoneNumberMaskedInput.jsx';

type Props = {
  onDone: Function,
  closable?: ?boolean,
  footer?: ?{},
  userMakingACall?: ?boolean,
};

type State = {
  submitting: boolean,
  phoneNumber: string,
};

class LinkSmsPhoneInputBox extends React.Component<Props, State> {
  state = {
    submitting: false,
    phoneNumber: '',
  };

  submitPhoneNumber = () => {
    const { phoneNumber } = this.state;

    const onSuccess = response => {
      this.setState({ submitting: false });

      this.props.onDone({
        token: response.token,
        phoneNumber,
      });
    };

    const onError = response => {
      this.setState({ submitting: false });

      if (response && response.code === 'duplicate_device') {
        ToastActions.showErrorToast('This device is already linked to your account.');
        return;
      }

      if (response && response.code === 'underage_account_conflict') {
        ToastActions.showErrorToast('Please contact support for assistance linking this device.');
        return;
      }

      if (response && response.code === 'validation_error') {
        const message =
          (response.error.endpoint && response.error.endpoint[0]) ||
          'Please enter a valid phone number.';
        ToastActions.showErrorToast(message);
        return;
      }

      ToastActions.showDefaultErrorToast();
    };

    this.setState({ submitting: true });

    DeviceActions.outboundVerify(phoneNumber).then(onSuccess, onError);
  };

  setStateField = (name: string, value: *) => {
    this.setState({ [name]: value });
  };

  render() {
    return (
      <div>
        <BoxHeader
          title={
            this.props.userMakingACall
              ? 'Add your mobile number to Remind to start making calls'
              : 'What is your mobile number?'
          }
          subtext="We’ll send you a code to connect your phone."
        />
        <BoxBody divided>
          <FormElement
            label="Phone number"
            labelHidden
            showErrorAfterBlur
            validate={e => {
              assertions.number(e.raw, 'Invalid phone number.');
              assertions.completePhoneNumber(e.raw, 'Invalid phone number.');
            }}
            onValidChange={i => this.setStateField('phoneNumber', i.raw)}
            onInvalidChange={() => this.setStateField('phoneNumber', undefined)}
            element={PhoneNumberMaskedInput}
            elementProps={{
              className: 'LinkSmsPhoneInputBox-input',
              placeholder: '(555) 555-5555',
              name: 'phone_number',
            }}
          />
          <Button
            className="LinkSmsPhoneInputBox-submit"
            disabled={this.state.submitting}
            type="submit"
            eventElementName="LinkSmsPhoneInputBox-Submit"
            onClick={this.submitPhoneNumber}>
            Send code
          </Button>
        </BoxBody>
        {this.props.footer ? <BoxFooter>{this.props.footer}</BoxFooter> : null}
      </div>
    );
  }
}
export default LinkSmsPhoneInputBox;
